import $ from 'jquery'
window.$ = $
window.jQuery = $

$(document).ready(function () {
    $(".form_option").click(function (){
        let button_buy = $(this).attr('buttonbuy')
        $(this).parent().parent().find('.button_box a').attr('href', button_buy)
    });
});